// @core/api/endpoints/team/list_temporary_role_assignments.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTemporaryRoleAssignmentsResponse,
} from '../../../types/team';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/team';

/**
 * List temporary role assignments
 * Returns a paginated list of temporary role assignments. Supports filtering and sorting.
 */
export async function ListTemporaryRoleAssignments(
  team_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTemporaryRoleAssignmentsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/temporary-assignments`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.get<ListTemporaryRoleAssignmentsResponse>(requestPath, { ...requestOptions, params });
}
